import { apiClient } from "./http";

// Blacklist API functions
export const blacklistSenderFromRFQ = async (rfqId: number, blacklistedBy: string, reason?: string, notes?: string) => {
  try {
    const response = await apiClient.post(`/blacklist/rfq/${rfqId}`, {
      blacklisted_by: blacklistedBy,
      reason: reason || 'Blacklisted from RFQ',
      notes: notes
    });
    return response.data;
  } catch (error) {
    console.error(`Error blacklisting sender from RFQ ${rfqId}:`, error);
    throw error;
  }
};

export const getBlacklistedSenders = async (activeOnly: boolean = true) => {
  try {
    const response = await apiClient.get(`/blacklist?active_only=${activeOnly}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching blacklisted senders:', error);
    throw error;
  }
};

export const removeBlacklistedSender = async (id: number) => {
  try {
    const response = await apiClient.delete(`/blacklist/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error removing blacklisted sender ${id}:`, error);
    throw error;
  }
};

export const reactivateBlacklistedSender = async (id: number) => {
  try {
    const response = await apiClient.patch(`/blacklist/${id}/reactivate`);
    return response.data;
  } catch (error) {
    console.error(`Error reactivating blacklisted sender ${id}:`, error);
    throw error;
  }
};
